module.exports = __webpack_public_path__ + "static/media/appnameNegative.6be0e437.png";